import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LiteralService } from 'src/app/services/literal/literal.service';

@Component({
  selector: 'app-operation-progress',
  templateUrl: './operation-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationProgressComponent {
  readonly percentage = input.required<number>();
  readonly detail = input<string>('');
  readonly title = input<string>('doingAction.title');
  readonly titleText = computed(() => this.literalService.get(this.title(), true));

  constructor(private readonly literalService: LiteralService) {}
}
